(function () {
  'use strict';
  if (window.__UM_MY_COLLECTION_PAGE__ || !window.UMMyCollection || !window.UMMyCollectionWall) return;
  window.__UM_MY_COLLECTION_PAGE__ = true;
  var store = window.UMMyCollection;
  var model = window.UMMyCollectionWall;
  var selected = new Set();
  var draft = null;
  var picking = false;
  var baseline = '';
  var baseWall = null;
  var editorOpen = false;
  var draftId = null, draftRevision = 0, draftSavedValue = '', draftError = '';
  var persistTimer, persistQueue = Promise.resolve(true), internalWrite = 0, saving = false;
  var lastAction = '', chooserTarget = null, chooserReturn = null;
  var tab = 'saved';
  var statuses = new Map();
  var checks = new Map();
  var collectionViewTracked = false;
  function trackCollectionView(data) {
    if (collectionViewTracked || !root()) return;
    collectionViewTracked = store.track('my_collection_view', {
      saved_count: data.favourites.length, wall_count: data.walls.length
    });
  }
  function trackWall(eventName, extra) {
    if (!draft) return;
    store.track(eventName, Object.assign({
      artwork_count: draft.artworks.length, layout: draft.layout,
      spacing: draft.spacing, wall_colour: draft.wallColour
    }, extra));
  }
  function root() { return document.querySelector('[data-um-my-collection-page]'); }
  function find(selector) { return root().querySelector(selector); }
  function el(tag, text, className) {
    var node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function button(text, action) { var node = el('button', text); node.type = 'button'; node.addEventListener('click', action); return node; }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function stamp() { return new Date().toISOString(); }
  function wallValue(wall) { return wall ? JSON.stringify({name:wall.name,layout:wall.layout,artworks:wall.artworks,spacing:wall.spacing,wallColour:wall.wallColour}) : ''; }
  function draftValue() { return wallValue(draft); }
  function dirty() {
    if (!draft) return false;
    if (picking && (selected.size !== draft.artworks.length || draft.artworks.some(function (a) { return !selected.has(a.productId); }))) return true;
    return draftValue() !== baseline;
  }
  async function write(change) { internalWrite++; try { return await store.mutate(change); } finally { internalWrite--; } }
  function updateStatus() {
    if (!draft || !find('[data-um-wall-status]')) return;
    find('[data-um-wall-status]').textContent = saving ? 'Saving wall…' : draftError || (dirty() ? 'Unsaved changes' + (lastAction ? ' · '+lastAction : '') : lastAction || 'Saved on this browser.');
    find('[data-um-discard-wall]').hidden = !dirty();
  }
  function persistDraft() {
    clearTimeout(persistTimer);
    if (!draft || !dirty()) return persistQueue;
    var record={id:draftId || 'draft-'+window.crypto.randomUUID(),wall:clone(draft),baseWall:baseWall?clone(baseWall):null};
    draftId=record.id;
    var value=JSON.stringify(record.wall);
    persistQueue=persistQueue.catch(function () {return false;}).then(async function () {
      if (!draft || draftId!==record.id || !dirty() || value===draftSavedValue) return true;
      try {
        await write(function (data) {
          var current=data.workingDraft;
          if (current && (current.id!==record.id || current.revision!==draftRevision) || !current && draftRevision>0) throw new Error('This working draft changed in another tab. Your changes are still open here; save a copy or reopen the latest draft.');
          record.revision=(current?current.revision:0)+1;record.updatedAt=stamp();data.workingDraft=record;
        });
        draftRevision=record.revision;draftSavedValue=value;draftError='';updateStatus();return true;
      } catch (error) {draftError=error.message;updateStatus();return false;}
    });
    return persistQueue;
  }
  function changed(action, interaction) {
    lastAction=action || '';draftError='';
    var next=model.compatible(draft.layout,draft.artworks.length);
    if (next!==draft.layout) {draft.layout=next;lastAction='Arrangement changed to '+model.presets(draft.artworks.length)[0].label+'.';}
    renderEditor();clearTimeout(persistTimer);persistTimer=setTimeout(persistDraft,180);
    if (interaction) trackWall(['layout','earlier','later','feature','swap'].includes(interaction)
      ? 'my_collection_wall_rearrange' : 'my_collection_wall_change', {action: interaction});
  }
  async function clearWorkingDraft() {
    clearTimeout(persistTimer);await persistQueue;
    try {
      await write(function (data) {
        if (data.workingDraft && (data.workingDraft.id!==draftId || data.workingDraft.revision!==draftRevision)) throw new Error('The working draft changed in another tab. Reopen it before discarding.');
        data.workingDraft=null;
      });
      draftId=null;draftRevision=0;draftSavedValue='';draftError='';return true;
    } catch (error) {store.message(error.message);return false;}
  }
  async function startDraft(wall, saved) {
    if (draft && dirty()) {
      if (!window.confirm('Start a different wall and discard the current working draft? Saved walls will stay unchanged.')) return false;
      if (!await clearWorkingDraft()) return false;
    }
    draft=model.normalise(clone(wall));baseWall=saved?model.normalise(clone(saved)):null;baseline=wallValue(baseWall);
    draftId=null;draftRevision=0;draftSavedValue='';draftError='';lastAction='';
    find('[data-um-name-editor]').hidden=true;
    picking=false;editorOpen=true;render();headingFocus();
    if (dirty()) persistDraft();
    trackWall('my_collection_wall_open', {source: saved ? 'saved_wall' : 'new_wall'});
    return true;
  }
  function headingFocus() { var h = find(editorOpen ? '[data-um-wall-title]' : 'h1'); if (h) h.focus(); }
  function showTab(next, focus) {
    if (next !== tab || editorOpen) store.track('my_collection_tab_view', {tab: next});
    if (draft && dirty()) persistDraft();
    editorOpen=false;picking=false;tab=next;
    render();
    if (focus) find('[data-um-tab="' + next + '"]').focus();
    return true;
  }
  function image(item) {
    var wrap = el('div', '', 'um-my-collection-image');
    if (item.imageUrl) {
      var img = el('img'); img.src = store.url(item.imageUrl, false); img.alt = item.title; img.loading = 'lazy';
      img.addEventListener('error', function () { wrap.replaceChildren(el('span', 'Image unavailable')); }, {once:true});
      wrap.appendChild(img);
    } else wrap.textContent = 'Image unavailable';
    return wrap;
  }
  function viewLink(item) {
    var state = statuses.get(item.handle);
    var target = state && state.parentOnly ? Object.assign({}, item, {variantId: ''}) : item;
    var productType = item.productType || (state && state.productType) || '';
    var a = el('a', productType.trim().toLowerCase() === 'map' ? 'View map' : 'View artwork'); a.href = store.productLink(target); return a;
  }
  function availability(item, parent) {
    var state = statuses.get(item.handle);
    if (state && state.message) parent.appendChild(el('p', state.message, 'um-my-collection-muted'));
    if (item.imageType === 'product-photo') parent.appendChild(el('p', 'Product-photo preview', 'um-my-collection-muted'));
  }
  var NS = 'http://www.w3.org/2000/svg';
  function composition(artworks, layout, label, appearance) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 1000 650'); svg.setAttribute('role', 'img'); svg.setAttribute('aria-label', label);
    svg.classList.add('um-my-collection-composition');
    svg.style.background=model.colours[appearance?.wallColour] || model.colours.warm;
    model.geometry(artworks,layout,appearance?.spacing).forEach(function (slot, index) {
      var item = artworks[index], art = document.createElementNS(NS, 'image');
      var group=document.createElementNS(NS,'g');
      Object.keys(slot).forEach(function (key) { art.setAttribute(key, slot[key]); });
      art.setAttribute('preserveAspectRatio', 'xMidYMid meet'); art.setAttribute('href', store.url(item.imageUrl, false));
      var title = document.createElementNS(NS, 'title'); title.textContent = item.title; art.appendChild(title);
      function missing() {
        art.remove(); var fallback = document.createElementNS(NS, 'text');
        fallback.setAttribute('x', slot.x + slot.width / 2); fallback.setAttribute('y', slot.y + slot.height / 2);
        fallback.setAttribute('text-anchor', 'middle'); fallback.setAttribute('font-size', '16'); fallback.textContent = 'Image unavailable'; group.appendChild(fallback);
      }
      art.addEventListener('error', missing, {once:true}); group.appendChild(art);svg.appendChild(group);
      if (!item.imageUrl) missing();
    });
    return svg;
  }
  async function change(fn, success, eventName, parameters) {
    try { await write(fn);render(); if (success) store.message(success); if (eventName) store.track(eventName, parameters); return true; }
    catch (error) { store.message(error.message); return false; }
  }
  function renderSaved(data) {
    var container = find('[data-um-saved-items]'); container.replaceChildren();
    var ids = new Set(data.favourites.map(function (a) { return a.productId; }));
    selected.forEach(function (id) { if (!ids.has(id)) selected.delete(id); });
    data.favourites.forEach(function (item) {
      var card = el('article', '', 'um-my-collection-card'); card.appendChild(image(item)); card.appendChild(el('h2', item.title));
      if (item.optionSummary && item.optionSummary !== 'Default Title') card.appendChild(el('p', item.optionSummary, 'um-my-collection-muted'));
      card.appendChild(viewLink(item)); availability(item, card);
      var add = button('Add to wall', function () { openWallChooser(item, add); });
      add.disabled = !!store.error(); card.appendChild(add);
      var label = el('label', '', 'um-my-collection-select'); var input = el('input'); input.type = 'checkbox'; input.checked = selected.has(item.productId);
      input.addEventListener('change', function () {
        if (input.checked && !selected.has(item.productId) && selected.size >= 6) { input.checked = false; store.message('Choose up to six artworks per wall.'); return; }
        if (input.checked) selected.add(item.productId); else selected.delete(item.productId);
        find('[data-um-see-together]').hidden = !selected.size;
      });
      label.append(input, document.createTextNode('Include in wall')); card.appendChild(label);
      var remove = button('Remove', async function () {
        if (await change(function (latest) { latest.favourites = latest.favourites.filter(function (a) { return a.productId !== item.productId; }); }, 'Removed from My Collection', 'my_collection_remove', {product_id:item.productId,variant_id:item.variantId || '',source:'collection'})) headingFocus();
      }); remove.setAttribute('aria-label', 'Remove ' + item.title + ' from My Collection'); card.appendChild(remove); container.appendChild(card);
    });
    find('[data-um-empty-saved]').hidden = !!data.favourites.length;
    find('[data-um-see-together]').hidden = !selected.size;
  }
  function openWall(wall) {
    if (draft?.id===wall.id && dirty()) {editorOpen=true;picking=false;render();headingFocus();trackWall('my_collection_wall_open',{source:'working_draft'});return;}
    startDraft(wall,wall);
  }
  function newWall(data, artworks) {
    var name = 'My first wall', n = 2;
    while (data.walls.some(function (wall) { return wall.name === name; })) name = 'My wall ' + n++;
    return {name:name,layout:model.presets(artworks.length)[0].id,artworks:clone(artworks)};
  }
  var wallChooserReturn = null;
  function closeWallChooser() {
    var dialog = find('[data-um-wall-chooser]');
    if (dialog.open) dialog.close();
    if (wallChooserReturn?.isConnected) wallChooserReturn.focus();
    else headingFocus();
  }
  function openWallChooser(item, returnTo) {
    try {
      var data = store.read(), dialog = find('[data-um-wall-chooser]'), list = find('[data-um-wall-choices]');
      wallChooserReturn = returnTo; list.replaceChildren();
      find('[data-um-wall-choice-status]').textContent = '';
      function choice(label, wall, current) {
        var control = button(label, async function () {
          control.disabled = true;
          try {
            var latest = store.read(), artwork = latest.favourites.find(function (a) { return a.productId === item.productId; });
            if (!artwork) throw new Error('That piece was removed from your collection. Choose another artwork.');
            var target = current ? draft : wall && latest.walls.find(function (w) { return w.id === wall.id; });
            if (wall && !target) throw new Error('That wall was deleted. Choose another wall.');
            if (target?.artworks.some(function (a) { return a.productId === item.productId; })) throw new Error('That artwork is already on this wall.');
            if (target?.artworks.length >= 6) throw new Error('This wall already has six artworks. Open it to replace a piece.');
            if (!target && latest.walls.length >= 10) throw new Error('You can save up to ten walls. Delete one first.');
            if (!current && !await startDraft(target || newWall(latest, []), target || null)) return;
            draft.artworks.push(clone(artwork)); picking=false;editorOpen=true;
            changed('', 'add_artwork'); render(); dialog.close(); headingFocus();
          } catch (error) { find('[data-um-wall-choice-status]').textContent = error.message; }
          finally { control.disabled = false; }
        });
        control.disabled = !!wall && (wall.artworks.length >= 6 || wall.artworks.some(function (a) { return a.productId === item.productId; }));
        list.appendChild(control);
      }
      choice('Create a new wall', null, false);
      if (draft) choice('Continue “' + draft.name + '”', draft, true);
      data.walls.forEach(function (wall) { if (wall.id !== draft?.id) choice(wall.name, wall, false); });
      dialog.showModal(); list.querySelector('button').focus();
    } catch (error) { store.message(error.message); }
  }
  function renderWalls(data) {
    var container = find('[data-um-wall-items]'); container.replaceChildren();
    data.walls.forEach(function (wall) {
      var card = el('article', '', 'um-my-collection-card');
      card.dataset.umWallId=wall.id;
      card.appendChild(composition(wall.artworks, wall.layout, wall.name,wall)); card.appendChild(el('h2', wall.name));
      card.appendChild(el('p', wall.artworks.length + (wall.artworks.length === 1 ? ' artwork' : ' artworks')));
      card.appendChild(button('Open', function () { openWall(wall); }));
      card.appendChild(button('Rename', async function () {
        var name = window.prompt('Wall name', wall.name); if (name === null) return;
        name = name.trim().slice(0, 80); if (!name) { store.message('Please enter a wall name.'); return; }
        if (await change(function (latest) {
          var target = latest.walls.find(function (w) { return w.id === wall.id; });
          if (!target || target.updatedAt !== wall.updatedAt) throw new Error('This wall changed in another tab. Reopen it before renaming.');
          target.name = name; target.updatedAt = stamp();
        }, 'Wall renamed')) headingFocus();
      }));
      card.appendChild(button('Delete', async function () {
        if (!window.confirm('Delete “' + wall.name + '”? Your saved artworks will stay in My Collection.')) return;
        if (await change(function (latest) {
          var target = latest.walls.find(function (w) { return w.id === wall.id; });
          if (target && target.updatedAt !== wall.updatedAt) throw new Error('This wall changed in another tab. Review it before deleting.');
          latest.walls = latest.walls.filter(function (w) { return w.id !== wall.id; });
        }, 'Wall deleted', 'my_collection_wall_delete', {artwork_count:wall.artworks.length,layout:wall.layout})) headingFocus();
      })); container.appendChild(card);
    });
    find('[data-um-empty-walls]').hidden = !!data.walls.length;
  }
  function renderEditor() {
    if (document.activeElement!==find('[data-um-wall-name]')) find('[data-um-wall-name]').value=draft.name;
    find('[data-um-wall-title]').textContent=draft.name || 'Untitled wall';
    find('[data-um-artwork-count]').textContent=draft.artworks.length+(draft.artworks.length===1?' artwork':' artworks');
    find('[data-um-save-wall]').disabled=saving || !draft.artworks.length || !!store.error();
    find('[data-um-copy-wall]').disabled=saving || !draft.artworks.length || !!store.error();
    find('[data-um-personalisation-notice]').hidden=!draft.artworks.some(function (a) {return a.personalisationNotSaved===true;});
    var choices=find('[data-um-wall-layout]');choices.replaceChildren();choices.hidden=draft.artworks.length<2;
    model.presets(draft.artworks.length).forEach(function (preset) {
      var choice=button('',function () {if(draft.layout===preset.id)return;draft.layout=preset.id;changed('', 'layout');find('[data-um-layout-value="'+preset.id+'"]').focus();});
      choice.dataset.umLayoutValue=preset.id;choice.setAttribute('aria-pressed',String(draft.layout===preset.id));
      var diagram=document.createElementNS(NS,'svg');diagram.setAttribute('viewBox','0 0 1000 650');diagram.setAttribute('aria-hidden','true');
      model.geometry(draft.artworks,preset.id,'regular').forEach(function (slot) {var rect=document.createElementNS(NS,'rect');Object.keys(slot).forEach(function (key) {rect.setAttribute(key,slot[key]);});diagram.appendChild(rect);});
      choice.append(diagram,el('span',preset.label));choices.appendChild(choice);
    });
    [['[data-um-spacing]','spacing',[['close','Close'],['regular','Regular'],['airy','Airy']]],['[data-um-wall-colour]','wallColour',[['warm','Warm white'],['stone','Stone'],['grey','Soft grey']]]].forEach(function (group) {
      var container=find(group[0]);container.replaceChildren();
      group[2].forEach(function (option) {
        var control=button(option[1],function () {if(draft[group[1]]===option[0])return;draft[group[1]]=option[0];changed('',group[1]==='wallColour'?'wall_colour':'spacing');find('[data-um-'+group[1]+'="'+option[0]+'"]').focus();});
        control.setAttribute('data-um-'+group[1],option[0]);control.setAttribute('aria-pressed',String(draft[group[1]]===option[0]));
        if (group[1]==='wallColour') {var swatch=el('span','','um-my-collection-swatch');swatch.style.background=model.colours[option[0]];control.prepend(swatch);}
        container.appendChild(control);
      });
    });
    find('[data-um-preview]').replaceChildren(composition(draft.artworks,draft.layout,'Wall arrangement preview',draft));
    if(!draft.artworks.length)find('[data-um-preview]').replaceChildren(el('p','Add a piece from your collection to begin.','um-my-collection-preview-empty'));
    find('[data-um-swap]').hidden=draft.artworks.length!==2;
    find('[data-um-add-artwork]').disabled=draft.artworks.length>=6;
    find('[data-um-add-artwork]').textContent=draft.artworks.length>=6?'Six artworks maximum':'+ Add artwork';
    var list = find('[data-um-editor-items]'); list.replaceChildren();
    draft.artworks.forEach(function (item, index) {
      var li=el('article','','um-my-collection-panel-item');li.dataset.umArtworkRow=item.productId;
      var artwork=el('div','','um-my-collection-panel-artwork');
      var title=el('span',item.title);title.title=item.title;artwork.append(image(item),title);li.appendChild(artwork);
      var actions=el('div','','um-my-collection-panel-actions');
      var replace=button('Replace',function () {openChooser(item.productId,replace);});replace.dataset.umReplace=item.productId;actions.append(replace,viewLink(item));
      if (draft.artworks.length>=3) ['Earlier', 'Later'].forEach(function (direction, d) {
        var next = index + (d ? 1 : -1);
        var move = button(direction, function () {
          var other = draft.artworks[next]; draft.artworks[next] = item; draft.artworks[index] = other;
          changed('',direction.toLowerCase());focusPanel(item.productId);
        }); move.dataset.umMove = String(d); move.disabled = next < 0 || next >= draft.artworks.length;
        move.setAttribute('aria-label', 'Move ' + item.title + ' ' + direction.toLowerCase()); actions.appendChild(move);
      });
      if (draft.layout==='feature' && index>0) actions.appendChild(button('Make feature',function () {draft.artworks.splice(index,1);draft.artworks.unshift(item);changed('','feature');focusPanel(item.productId);}));
      var remove=button('Remove',function () {draft.artworks.splice(index,1);var nextId=draft.artworks[Math.min(index,draft.artworks.length-1)]?.productId;changed('','remove_artwork');if(nextId)focusPanel(nextId);else find('[data-um-add-artwork]').focus();});
      remove.dataset.umRemove=item.productId;remove.className='um-my-collection-text-button';remove.setAttribute('aria-label','Remove '+item.title+' from this wall');actions.appendChild(remove);li.appendChild(actions);availability(item,li);list.appendChild(li);
    });
    updateStatus();
  }
  function focusPanel(id) {
    var row=Array.from(find('[data-um-editor-items]').children).find(function (item) {return item.dataset.umArtworkRow===id;});
    if (row) row.querySelector('[data-um-replace]').focus();
  }
  function closeChooser() {
    var dialog=find('[data-um-chooser]');if(dialog.open)dialog.close();
    if (chooserReturn?.isConnected) chooserReturn.focus();else find('[data-um-add-artwork]').focus();
  }
  function openChooser(target,returnTo) {
    try {
      var data=store.read();chooserTarget=target;chooserReturn=returnTo;
      var dialog=find('[data-um-chooser]'), list=find('[data-um-chooser-items]');list.replaceChildren();
      find('#um-my-collection-chooser-title').textContent=target?'Choose a replacement':'Add artwork';
      var available=data.favourites.filter(function (a) {return !draft.artworks.some(function (b) {return b.productId===a.productId;});});
      find('[data-um-chooser-empty]').hidden=!!available.length;
      available.forEach(function (item) {
        var choice=button('',function () {
          try {
            var latest=store.read().favourites.find(function (a) {return a.productId===item.productId;});
            if (!latest) throw new Error('That piece was removed from your collection. Choose another artwork.');
            if (draft.artworks.some(function (a) {return a.productId===item.productId;})) throw new Error('That artwork is already on this wall.');
            if (chooserTarget) {var index=draft.artworks.findIndex(function (a) {return a.productId===chooserTarget;});if(index<0)throw new Error('Choose the artwork to replace again.');draft.artworks[index]=clone(latest);}
            else {if(draft.artworks.length>=6)throw new Error('Choose up to six artworks per wall.');draft.artworks.push(clone(latest));}
            changed('',chooserTarget?'replace_artwork':'add_artwork');closeChooser();focusPanel(item.productId);
          } catch (error) {store.message(error.message);}
        });choice.dataset.umChooseArtwork=item.productId;choice.append(image(item),el('span',item.title));list.appendChild(choice);
      });
      if (!dialog.open) dialog.showModal();
      (list.querySelector('button') || find('[data-um-close-chooser]')).focus();
    } catch (error) {store.message(error.message);}
  }
  function render() {
    if (!root() || !find('[data-um-saved-items]')) return;
    var data = store.sync();
    root().classList.toggle('is-editing',editorOpen);
    find('[role="tablist"]').hidden=editorOpen;find('[data-um-collection-intro]').hidden=editorOpen;
    find('[data-um-my-collection-persistence]').hidden=editorOpen;
    find('[data-um-collection-actions]').hidden=editorOpen;
    root().querySelectorAll('[data-um-create-wall]').forEach(function (control) {control.disabled=!!store.error();});
    root().querySelectorAll('[data-um-tab]').forEach(function (node) {var active=!editorOpen && node.dataset.umTab===tab;node.setAttribute('aria-selected',String(active));node.tabIndex=active?0:-1;});
    find('#um-my-collection-saved').hidden=editorOpen || tab!=='saved';find('#um-my-collection-walls').hidden=editorOpen || tab!=='walls';
    find('[data-um-editor]').hidden=!editorOpen;find('[data-um-resume]').hidden=!draft || editorOpen;
    if(draft)find('[data-um-resume-title]').textContent='Continue “'+(draft.name || 'Untitled wall')+'”';
    renderSaved(data);renderWalls(data);if(editorOpen && draft)renderEditor();
    return data;
  }
  async function saveWall(copy) {
    if (!draft || saving) return;
    draft.name = find('[data-um-wall-name]').value.trim();
    if (!draft.name) { store.message('Please enter a wall name.');find('[data-um-name-editor]').hidden=false;find('[data-um-wall-name]').focus();return; }
    if (!draft.artworks.length) { store.message('Choose at least one artwork.'); return; }
    clearTimeout(persistTimer);await persistQueue;
    var saveType=copy?'copy':draft.id?'update':'create';
    var candidate=clone(draft);saving=true;updateStatus();
    var ok=await change(function (data) {
      if(copy){
        var original=candidate.name,suffix=' — copy',number=2;candidate.name=original.slice(0,80-suffix.length)+suffix;
        while(data.walls.some(function(w){return w.name===candidate.name;})){suffix=' — copy '+number++;candidate.name=original.slice(0,80-suffix.length)+suffix;}
        delete candidate.id;delete candidate.createdAt;delete candidate.updatedAt;
      }
      var index = candidate.id ? data.walls.findIndex(function (w) { return w.id === candidate.id; }) : -1;
      if (candidate.id && (index < 0 || data.walls[index].updatedAt !== candidate.updatedAt)) throw new Error('This wall changed or was deleted in another tab. Your draft is still open. Reopen the saved wall to edit its latest version.');
      if (!candidate.id && data.walls.length >= 10) throw new Error('You can save up to ten walls. Delete one first.');
      if(!copy && data.workingDraft && (data.workingDraft.id!==draftId || data.workingDraft.revision!==draftRevision)) throw new Error('The working draft changed in another tab. Save a copy to keep your version.');
      candidate.id = candidate.id || 'wall-' + window.crypto.randomUUID();
      candidate.createdAt = candidate.createdAt || stamp(); candidate.updatedAt = stamp();
      if (index >= 0) data.walls[index] = candidate; else data.walls.push(candidate);
      if (data.workingDraft?.id===draftId && data.workingDraft.revision===draftRevision) data.workingDraft=null;
    });
    saving=false;
    if(ok){draft=model.normalise(candidate);baseWall=clone(draft);baseline=draftValue();draftId=null;draftRevision=0;draftSavedValue='';draftError='';lastAction='Wall saved';find('[data-um-name-editor]').hidden=true;render();trackWall('my_collection_wall_save',{save_type:saveType});}
    else {lastAction='Your wall has not been saved.';updateStatus();}
  }
  async function lookup(item) {
    if (checks.has(item.handle)) return checks.get(item.handle);
    var promise = (async function () {
      try {
        var response = await fetch(store.config.dataset.root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(item.handle) + '.js', {credentials:'same-origin'});
        if (!response.ok) throw new Error(response.status === 404 ? 'This artwork may no longer be available. Your saved preview is kept.' : 'Availability could not be checked. Check the product page.');
        var data = await response.json();
        if (String(data.id) !== item.productId || !Array.isArray(data.variants)) throw new Error('Availability could not be checked. Check the product page.');
        var state = {message: data.available === false ? 'Currently unavailable. Your saved preview is kept.' : '', parentOnly: false,
          productType: typeof data.type === 'string' ? data.type : ''};
        // A missing variant may simply be outside the endpoint’s variant limit.
        if (item.variantId && !data.variants.some(function (v) { return String(v.id) === item.variantId; })) {
          state.message = 'Check your saved size and finish on the product page; that option could not be verified.'; state.parentOnly = true;
        }
        statuses.set(item.handle, state);
      } catch (error) { statuses.set(item.handle, {message: error.message === 'Failed to fetch' ? 'Availability could not be checked. Check the product page.' : error.message, parentOnly:true}); }
    })(); checks.set(item.handle, promise); return promise;
  }
  async function refreshAvailability(data) {
    if (!data) return;
    var items = data.favourites.concat(data.walls.flatMap(function (w) { return w.artworks; }));
    var queue = items.filter(function (item, index) { return items.findIndex(function (a) { return a.handle === item.handle; }) === index && !checks.has(item.handle); });
    if (!queue.length) return;
    await Promise.all(Array.from({length: Math.min(4, queue.length)}, async function () { while (queue.length) await lookup(queue.shift()); }));
    // Preserve input/keyboard focus: availability updates can wait until next interaction.
    if (!root().contains(document.activeElement)) render();
  }
  async function qaSeed() {
    if (store.config.dataset.debug !== 'true' || !window.Shopify.designMode) return;
    var handles = Array.from(new Set(find('[data-um-qa-handles]').value.split(',').map(function (s) { return s.trim(); }).filter(Boolean)));
    if (handles.length < 3 || handles.length > 6 || !handles.every(function (s) { return /^[a-zA-Z0-9-]+$/.test(s); })) { store.message('Enter three to six real product handles.'); return; }
    try {
      var items = await Promise.all(handles.map(async function (handle) {
        var response = await fetch(store.config.dataset.root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'});
        if (!response.ok) throw new Error('Could not load QA product: ' + handle);
        var p = await response.json();
        var img = p.featured_image && (p.featured_image.src || p.featured_image);
        var media = Array.isArray(p.media) && p.media.find(function (m) { return m.preview_image; });
        var ratio = media && Number(media.preview_image.aspect_ratio);
        return {productId:String(p.id), handle:p.handle, title:p.title, url:store.productLink({handle:p.handle}), imageUrl:store.url(img || '', false), aspectRatio:ratio > 0 && ratio < 100 ? ratio : 1, imageType:'product-photo', optionSummary:'', savedAt:stamp(), qa:true};
      }));
      await change(function (data) {
        items.forEach(function (item) { if (!data.favourites.some(function (a) { return a.productId === item.productId; })) data.favourites.push(item); });
      }, 'QA artwork added. Existing favourites were kept.');
    } catch (error) { store.message(error.message); }
  }
  document.addEventListener('click', async function (event) {
    var link = event.target.closest('a[href]');
    if (link && root()?.contains(link) && dirty() && !link.getAttribute('href').startsWith('#')) {
      if (link.target==='_blank' || event.ctrlKey || event.metaKey) persistDraft();
      else {
        event.preventDefault();
        if (await persistDraft() || window.confirm('Your working draft could not be stored. Leave without keeping these changes?')) window.location.assign(link.href);
        return;
      }
    }
    var target = event.target.closest('button'); if (!target || !root() || !root().contains(target)) return;
    if (target.dataset.umTab) showTab(target.dataset.umTab, true);
    else if (target.matches('[data-um-create-wall]')) {
      try {
        var latest = store.read();
        if (latest.walls.length >= 10) {store.message('You can save up to ten walls. Delete one first.');return;}
        if (await startDraft(newWall(latest, []), null)) openChooser(null, find('[data-um-add-artwork]'));
      } catch (error) {store.message(error.message);}
    }
    else if (target.matches('[data-um-close-wall-chooser]')) closeWallChooser();
    else if (target.matches('[data-um-see-together]')) {
      try {
        var data = store.read(), artworks = data.favourites.filter(function (a) { return selected.has(a.productId); });
        if (!artworks.length || artworks.length > 6) { store.message('Choose one to six artworks.'); return; }
        if (draft && picking) {
          var ordered=clone(draft.artworks);
          artworks.forEach(function (a) { if (!ordered.some(function (b) { return b.productId === a.productId; })) ordered.push(a); });
          if(ordered.length>6){store.message('Choose up to six artworks per wall. Your existing pieces have been kept.');return;}
          draft.artworks=clone(ordered);picking=false;editorOpen=true;changed('','add_artwork');render();headingFocus();
        } else await startDraft(newWall(data, artworks),null);
      } catch (error) { store.message(error.message); }
    } else if (target.matches('[data-um-save-wall]')) saveWall(false);
    else if (target.matches('[data-um-copy-wall]')) saveWall(true);
    else if (target.matches('[data-um-edit-name]')) {find('[data-um-name-editor]').hidden=false;find('[data-um-wall-name]').focus();find('[data-um-wall-name]').select();}
    else if (target.matches('[data-um-name-done]')) {find('[data-um-name-editor]').hidden=true;find('[data-um-edit-name]').focus();persistDraft();}
    else if (target.matches('[data-um-add-artwork]')) openChooser(null,target);
    else if (target.matches('[data-um-close-chooser],[data-um-cancel-chooser]')) closeChooser();
    else if (target.matches('[data-um-swap]') && draft?.artworks.length===2) {draft.artworks.reverse();changed('','swap');find('[data-um-swap]').focus();}
    else if (target.matches('[data-um-browse-saved]')) {closeChooser();selected=new Set(draft.artworks.map(function(a){return a.productId;}));picking=true;editorOpen=false;tab='saved';persistDraft();render();headingFocus();}
    else if (target.matches('[data-um-back-walls]')) {await persistDraft();showTab('saved');headingFocus();}
    else if (target.matches('[data-um-resume-wall]')) {editorOpen=true;picking=false;render();headingFocus();trackWall('my_collection_wall_resume');}
    else if (target.matches('[data-um-discard-wall]')) {
      if(!await clearWorkingDraft())return;
      trackWall('my_collection_wall_discard');
      var saved=draft.id && store.read().walls.find(function(w){return w.id===draft.id;});
      if(saved){draft=model.normalise(clone(saved));baseWall=clone(draft);baseline=draftValue();lastAction='Saved version restored';}
      else{draft=null;baseWall=null;baseline='';editorOpen=false;tab='walls';}
      render();headingFocus();
    }
    else if (target.matches('[data-um-qa-seed]')) qaSeed();
    else if (target.matches('[data-um-qa-clear]') && store.config.dataset.debug === 'true' && window.Shopify.designMode) {
      if(draft?.artworks.some(function(a){return a.qa;})){clearTimeout(persistTimer);await persistQueue;draft=null;editorOpen=false;draftId=null;draftRevision=0;}
      change(function (data) {
      data.favourites = data.favourites.filter(function (a) { return !a.qa; });
      // Walls containing QA pieces are explicitly QA data; ordinary walls stay independent.
      data.walls = data.walls.filter(function (w) { return !w.artworks.some(function (a) { return a.qa; }); });
      if(data.workingDraft?.wall.artworks.some(function(a){return a.qa;})) data.workingDraft=null;
    }, 'QA favourites and walls containing QA artwork cleared.');
    }
  }, true);
  document.addEventListener('input', function (event) { if (draft && event.target.matches('[data-um-wall-name]')) {draft.name=event.target.value;changed();} });
  document.addEventListener('keydown', function (event) {
    if(event.target.matches('[data-um-wall-name]') && event.key==='Enter'){event.preventDefault();find('[data-um-name-done]').click();return;}
    if (!event.target.matches('[data-um-tab]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault(); showTab(event.key === 'Home' ? 'saved' : event.key === 'End' ? 'walls' : event.target.dataset.umTab === 'saved' ? 'walls' : 'saved', true);
  });
  window.addEventListener('beforeunload', function (event) { if (dirty() && (draftError || draftSavedValue!==JSON.stringify(draft))) {event.preventDefault();event.returnValue='';} });
  window.addEventListener('pagehide',function () {if(dirty())persistDraft();});
  document.addEventListener('shopify:section:load', function () { render(); });
  document.addEventListener('cancel',function(event){if(event.target.matches('[data-um-chooser]')){event.preventDefault();closeChooser();}},true);
  document.addEventListener('cancel',function(event){if(event.target.matches('[data-um-wall-chooser]')){event.preventDefault();closeWallChooser();}},true);
  function restoreDraft(open) {
    if(draft)return;
    try {
      var stored=store.read().workingDraft;
      if(stored){draft=model.normalise(clone(stored.wall));baseWall=stored.baseWall?model.normalise(clone(stored.baseWall)):null;baseline=wallValue(baseWall);draftId=stored.id;draftRevision=stored.revision;draftSavedValue=JSON.stringify(draft);editorOpen=open;lastAction='Working draft restored';}
    } catch (_) { /* The store displays the actual storage/consent error. */ }
  }
  store.subscribe(function () {if(internalWrite)return;restoreDraft(false);var data=render();if(data)trackCollectionView(data);refreshAvailability(data);});
  restoreDraft(true);
  var initial = render(); if(initial)trackCollectionView(initial);refreshAvailability(initial);
})();
